import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "react-datepicker/dist/react-datepicker.css";
import index from "./js/index";
import store from "./store/index";


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// store.subscribe(() =>
// {
// console.log('index change!!'+store.getState().lang);
// localStorage.setItem('lang', store.getState().lang);
// if(store.getState().lang==='ar')
// {
//     document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
// }
// else{
//     document.getElementsByTagName('html')[0].setAttribute("dir", "ltr");

// }

// });

// if(localStorage.getItem('lang')==='ar')
// {
//     document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
// }
// else{
//     document.getElementsByTagName('html')[0].setAttribute("dir", "ltr");

// }

serviceWorker.unregister();
